<template>
  <div class="game-session">
    <div class="locked-bet-button">🔒</div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
@use '@/scss/tokens.scss' as main;

.locked-bet-button {
  padding: 0.5rem;
  position: relative;
}
</style>
